module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', [(_vm.isShowAside) ? _c('el-aside', {
    staticClass: "aside",
    class: {
      'no-sub': _vm.$route.meta && _vm.$route.meta.hideMenu
    }
  }, [_c('div', {
    staticClass: "menu-warp view-flex"
  }, [_c('div', {
    staticClass: "menu-scroll"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": {
        path: _vm.path_prefixes ? '/' + _vm.path_prefixes : '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.brandIco,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": _vm.$route.matched[0].path ? _vm.$route.matched[0].path : _vm.$route.matched[1].path,
      "background-color": _vm.theme.$auxiliary_hue,
      "text-color": "#fff",
      "active-text-color": _vm.theme.$auxiliary_hue
    },
    on: {
      "select": _vm.handleChange
    }
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.path
      },
      on: {
        "click": function($event) {
          return _vm.toRoute(item.path)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: 'iconfont icon-' + item.iconCls
    }), _vm._v(" " + _vm._s(item.name) + "\n            ")]) : _vm._e()
  }), 1)], 1)]), _vm._v(" "), (_vm.$route.meta && !_vm.$route.meta.hideMenu) ? _vm._l((_vm.$router.options.routes), function(item, index) {
    return (_vm.isCurrentSubmenu(item.path)) ? _c('div', {
      staticClass: "menu-scroll"
    }, [_c('el-menu', {
      staticClass: "sub-menu",
      attrs: {
        "default-active": _vm.$route.matched.length > 3 ? _vm.$route.matched[_vm.$route.matched.length - 2].path : _vm.$route.path,
        "background-color": _vm.theme.$submenu_bg,
        "text-color": _vm.theme.$submenu_text,
        "active-text-color": _vm.theme.$submenu_act_text,
        "router": ""
      }
    }, [_vm._l((item.children), function(child, index) {
      return (!child.hidden) ? [(child.isLeaf) ? _c('el-menu-item-group', {
        staticClass: "menu-group"
      }, [_c('template', {
        slot: "title"
      }, [_vm._v(_vm._s(child.name))]), _vm._v(" "), _vm._l((child.children), function(sub, index) {
        return [(!sub.hidden) ? _c('el-menu-item', {
          key: sub.path,
          attrs: {
            "index": sub.path
          }
        }, [_vm._v(_vm._s(sub.name))]) : _vm._e()]
      })], 2) : _c('div', {
        staticClass: "menu-group"
      }, [_c('el-menu-item', {
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))])], 1)] : _vm._e()
    })], 2)], 1) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "z-index": "9999",
      "padding": "3px 7px",
      "font-size": "16px"
    },
    attrs: {
      "icon": "el-icon-menu",
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.showAside
    }
  }), _vm._v(" "), _c('el-container', [_c('el-header', {
    staticClass: "header",
    attrs: {
      "height": "50px"
    }
  }, [_c('div', {
    staticClass: "view-flex-item"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-middle"
  }, [_c('div', {
    staticClass: "icon-nav"
  }, [(this.$store.getters.login_type == 'distributor') ? _c('el-badge', [_c('i', {
    staticClass: "iconfont icon-store-alt",
    on: {
      "click": _vm.handleClickSelectShop
    }
  })]) : _vm._e()], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "icon-nav"
  }, [_c('el-badge', {
    attrs: {
      "is-dot": ""
    }
  }, [_c('i', {
    staticClass: "iconfont icon-bell"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-setting"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover",
      "popper-class": "logout-popper"
    },
    model: {
      value: (_vm.visible2),
      callback: function($$v) {
        _vm.visible2 = $$v
      },
      expression: "visible2"
    }
  }, [_c('div', {
    staticClass: "content-padded dom-link",
    on: {
      "click": _vm.handleUserInfo
    }
  }, [_c('div', {
    staticClass: "view-flex view-flex-middle"
  }, [(_vm.avatar) ? _c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.avatar
    }
  }) : _c('i', {
    staticClass: "user-avatar iconfont icon-user-circle1"
  }), _vm._v(" "), _c('div', [_c('div', [_vm._v(_vm._s(_vm.nick_name || _vm.name))]), _vm._v(" "), _c('small', {
    staticClass: "muted"
  }, [_vm._v("基础信息")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border small dom-link muted",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")]), _vm._v(" "), (_vm.avatar) ? _c('img', {
    staticClass: "user-avatar",
    attrs: {
      "slot": "reference",
      "src": _vm.avatar
    },
    slot: "reference"
  }) : _c('i', {
    staticClass: "iconfont icon-user-circle1",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)])]), _vm._v(" "), _c('el-main', [_c('section', {
    staticClass: "content-container",
    attrs: {
      "id": "container"
    }
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b3d029d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b3d029d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/layout.vue
// module id = 2636
// module chunks = 0